import { useMemo } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useTripSearchLogic } from "hooks/useTripSearchLogic"

const MIN_SEARCH_CHARS = 3

export const useListingsDerivedData = ({ search, trips }) => {
  const { t } = useTranslation()
  const categories = useSelector((state) => state.trips.categories.data?.categories || [])

  const categoryOptions = useMemo(() => categories.map((c) => ({ value: c.id, label: c.name })), [categories])

  const durationOptions = useMemo(
    () => [
      { value: "single_day", label: t("experiences.filters.single_day", { defaultValue: "Single Day" }) },
      { value: "multi_day", label: t("experiences.filters.multi_day", { defaultValue: "Multi Day" }) }
    ],
    [t]
  )

  const useSearchTrips =
    (search.showSuggestions && search.debouncedSearchQuery.trim()) ||
    (search.debouncedSearchQuery.trim().length >= MIN_SEARCH_CHARS && !search.confirmedSearchQuery.trim())

  const { categorizedSearchResults } = useTripSearchLogic({
    trips: useSearchTrips ? search.searchTrips : trips,
    searchQuery: search.searchQuery,
    selectedTrip: search.selectedTrip,
    debouncedSearchQuery: search.debouncedSearchQuery,
    showSuggestions: search.showSuggestions
  })

  const tripsForMainList = useMemo(() => {
    if (search.selectedTrip) return [search.selectedTrip]
    if (search.confirmedSearchQuery.trim()) return search.searchTrips
    return trips
  }, [search.selectedTrip, search.confirmedSearchQuery, search.searchTrips, trips])

  return { categoryOptions, durationOptions, categorizedSearchResults, tripsForMainList }
}
